import React from 'react';

import { Button, ContainerHeader, ErrorResponse, Spinner } from '~components';
import { faMoneyBill } from '~components/icon';

import { useOAuthCallbackFlow } from './useOAuthCallbackFlow';

interface CallbackShellProps {
  dataCy: string;
  children: React.ReactNode;
}

const CallbackShell: React.FC<CallbackShellProps> = ({ dataCy, children }) => (
  <div className="p-2">
    <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="dd-oauth-callback-header">
      Direct Debits — GoCardless
    </ContainerHeader>
    <div className="p-3" data-cy={dataCy}>
      {children}
    </div>
  </div>
);

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => (
  <Button color="outline-primary" className="mt-3" onClick={onClick} dataCy="dd-oauth-callback-back-btn">
    Back to Direct Debits
  </Button>
);

const OAuthCallbackHandler: React.FC = () => {
  const { status, errorMessage, handleBack } = useOAuthCallbackFlow();

  if (status !== 'loading') {
    return (
      <CallbackShell dataCy="dd-oauth-callback-error">
        <ErrorResponse message={errorMessage} />
        <BackButton onClick={handleBack} />
      </CallbackShell>
    );
  }

  return (
    <CallbackShell dataCy="dd-oauth-callback-loading">
      <div className="p-5 text-center">
        <Spinner loading />
        <p className="mt-3 text-muted">Connecting your GoCardless account...</p>
      </div>
    </CallbackShell>
  );
};

export default OAuthCallbackHandler;
